import SignatureWrapper from '@/common/components/base/signatureCanvas/SignatureWrapper.tsx';
import EditSign from '@/common/components/base/signatureCanvas/signActions/editSign/EditSign.tsx';
import { Box } from 'styled-system/jsx';
import EditSignModal from '@/common/components/base/signatureCanvas/signActions/editSign/EditSignModal.tsx';
import { UseSignatureReturn } from '@/common/hooks/useSignature.ts';
import useModal from '@/common/hooks/useModal.ts';
import { css } from 'styled-system/css';

const SignaturePreview = ({
  image,
  exitPreviewMode,
}: {
  image: string;
} & Pick<UseSignatureReturn, 'exitPreviewMode'>) => {
  const { open, closeModal, openModal } = useModal();
  return (
    <>
      <SignatureWrapper>
        <Box width="100%" height="calc(100% - 40px)">
          <img
            className={css({ w: '100%', h: '100%', objectFit: 'contain' })}
            src={image}
            alt=""
          />
        </Box>
        <EditSign onClick={openModal} />
      </SignatureWrapper>
      <EditSignModal
        exitPreviewMode={exitPreviewMode}
        open={open}
        closeModal={closeModal}
      />
    </>
  );
};

export default SignaturePreview;
